<template>
  <div id="app">
    <router-view />
    <!-- <ButtonTelegram /> -->
  </div>
</template>

<script>
export default {};
</script>

<style>
body,
#app {
  inset: 0;
  margin: 0;
  padding: 0;
  background: radial-gradient(
    123.22% 129.67% at 100.89% -5.6%,
    #201d47 0,
    #17153a 100%
  );
}

*,
::after,
::before {
  box-sizing: border-box;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

details summary {
  list-style: none; /* убираем дефолтный маркер */
}

details summary::-webkit-details-marker {
  display: none;
}
summary {
  list-style: none; /* убираем маркер в списках */
  -webkit-appearance: none; /* для Safari и iOS */
  appearance: none; /* общий вариант */
}

summary::-webkit-details-marker {
  display: none;
}
</style>

<style scoped>
@import "./assets/css/Repainting/StyleVars.css";
@import "./assets/css/Repainting/Scroll.css";
@import "./assets/css/Repainting/Element.css";
@import "./assets/css/Repainting/VQuillTheme.css";
@import "./assets/css/Repainting/Fonts.css";
/* @import "./assets/css/Repainting/Dialogs.css"; */
/* @import "./assets/css/Repainting/newStyle.css"; */
/* @import "./assets/css/Repainting/Buttons.css";
@import "./assets/css/Repainting/Organization.css"; */
/* 
@import "./assets/css/Repainting/Checkboxes.css";
@import "./assets/css/Repainting/FiltersDropDown.css";
@import "./assets/css/Repainting/Adaptation.css";
@import "./assets/css/Repainting/VQuillTheme.css";
@import "./assets/css/Repainting/Modal.css";
 */
</style>
